import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=d2924f48&scoped=true"
import script from "./credits.vue?vue&type=script&lang=js"
export * from "./credits.vue?vue&type=script&lang=js"
import style0 from "./credits.vue?vue&type=style&index=0&id=d2924f48&prod&lang=scss&scoped=true"
import style1 from "./credits.vue?vue&type=style&index=1&id=d2924f48&prod&scoped=true&lang=css"
import style2 from "./credits.vue?vue&type=style&index=2&id=d2924f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2924f48",
  null
  
)

export default component.exports